"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5435],{

/***/ 7890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPushkin = function SvgPushkin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.621 37.4c1.094-2.363 1.876-5.514-2.812-5.199m0 0c-3.5.378-3.126-1.417-2.5-2.363.312-.472.575-1.569.575-2.514m1.925 4.877c3.5-.378 8.484-4.231 12.39-3.601M9.885 27.324c-.325-1.087-.808-1.384-1.513-2.527-1.042-.052-2.72-.472-1.094-1.733C9.308 21.49 12.1 18.7 13.2 15.4M9.884 27.325c.84-.104 2.601-.337 2.919-.443m9.788 8.155c.486-.642 2.518-2.532 6.925-2.404 4.407.129 4.645-2.087 4.213-3.211 6.97 0 4.77-10.722.867-11.522 1.944-9.154-3.46-8.873-4.594-8.873C28.6 3.3 19.8 3.3 17.85 6.94c-7.95 0-2.45 7.36 3.05 7.36 5.995.752 5.5 3.3 5.5 5.5 0 0-.535 2.698-4.813 2.056C18.7 22 17.6 23.1 16.5 24.2",
    stroke: "#F44336",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m16.146 17.075 2.582.963-.796.796",
    stroke: "#F44336",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgPushkin);

/***/ }),

/***/ 5629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgRedRouble = function SvgRedRouble(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    fill: "#f44336",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M83.3 243.5c-7 0-12.6-5.7-12.6-12.6V28.1c0-7 5.7-12.6 12.6-12.6 7 0 12.6 5.7 12.6 12.6v202.7c.1 7-5.6 12.7-12.6 12.7z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M151.6 155.5H48.7c-7 0-12.6-5.7-12.6-12.6 0-7 5.7-12.6 12.6-12.6h102.9c24.6 0 44.6-20 44.6-44.6s-20-44.6-44.6-44.6H83.3c-7 0-12.6-5.7-12.6-12.7s5.7-12.6 12.6-12.6h68.3c38.6 0 69.9 31.4 69.9 69.9 0 38.3-31.3 69.8-69.9 69.8zm40.7 44H48.7c-7 0-12.6-5.7-12.6-12.6 0-7 5.7-12.6 12.6-12.6h143.6c7 0 12.6 5.7 12.6 12.6.1 7-5.6 12.6-12.6 12.6z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgRedRouble);

/***/ }),

/***/ 7581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgStarOutline = function SvgStarOutline(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 16,
    viewBox: "0 0 16 15",
    fill: "transparent"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.896.57A.09.09 0 0 1 7.93.52.125.125 0 0 1 8 .5c.03 0 .053.009.069.019a.09.09 0 0 1 .035.051l1.472 4.446c.15.455.579.756 1.053.756h4.761c.038 0 .058.01.07.02.014.01.027.027.034.05a.095.095 0 0 1 .003.056c-.003.01-.01.027-.04.048l-3.851 2.748c-.39.277-.557.775-.406 1.232l1.472 4.446c.01.03.006.046.002.056a.107.107 0 0 1-.04.048.124.124 0 0 1-.066.024.108.108 0 0 1-.068-.024l-3.852-2.748a1.118 1.118 0 0 0-1.296 0L3.5 14.476a.108.108 0 0 1-.068.024.124.124 0 0 1-.067-.024.108.108 0 0 1-.04-.048c-.003-.01-.007-.026.003-.056L4.8 9.926a1.092 1.092 0 0 0-.406-1.232L.542 5.946c-.029-.02-.036-.038-.039-.048a.095.095 0 0 1 .003-.056.105.105 0 0 1 .035-.05c.01-.01.03-.02.069-.02h4.76c.475 0 .904-.3 1.055-.756L7.895.57Z",
    stroke: "#BFC1C3"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgStarOutline);

/***/ }),

/***/ 1245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgWhen = function SvgWhen(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    fill: "#f44336",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M190 115.6H66v24.8h124v-24.8zm24.8-86.8h-12.4V4h-24.8v24.8H78.4V4H53.6v24.8H41.2c-13.8 0-24.7 11.2-24.7 24.8l-.1 173.6c0 13.7 11.1 24.8 24.8 24.8h173.6c13.6 0 24.8-11.2 24.8-24.8V53.6c0-13.6-11.2-24.8-24.8-24.8zm0 198.4H41.2V90.8h173.6v136.4zm-62-62H66V190h86.8v-24.8z"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgWhen);

/***/ }),

/***/ 5435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ PostCard; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(917);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(1463);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(120);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3751);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_timer_hook__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _public_img_redRouble_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5629);
/* harmony import */ var _public_img_when_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1245);
/* harmony import */ var _public_img_location_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1271);
/* harmony import */ var _public_img_views2_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3148);
/* harmony import */ var _public_img_star_outline_svg__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7581);
/* harmony import */ var _public_img_pushkin_svg__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7890);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6535);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6880);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3349);
/* harmony import */ var _picture_picture__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2786);
/* harmony import */ var _styled_Link__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6196);
/* harmony import */ var _lib_consts__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9006);
/* harmony import */ var _favorite_FavoriteButton__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7344);
/* harmony import */ var _favorite_FavoriteButtonCardWrapper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(146);
/* harmony import */ var _models_favorite__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(494);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5944);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

























var _ref2 =  true ? {
  name: "nu06ps",
  styles: "border-radius:4px;position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden"
} : 0;

var _ref3 =  true ? {
  name: "1pi274v",
  styles: "width:100%;background:rgba(0, 0, 0, 0.7);color:#fff;padding:6px 0;z-index:10;position:absolute;left:0;bottom:0"
} : 0;

var _ref4 =  true ? {
  name: "lesovd",
  styles: "width:90%;margin:0 auto"
} : 0;

var _ref5 =  true ? {
  name: "1cxr13n",
  styles: "text-align:center;font-size:13px"
} : 0;

var _ref6 =  true ? {
  name: "1wox62x",
  styles: "width:100%;height:3px;background:#fff;border-radius:2px;margin-top:5px"
} : 0;

var _ref7 =  true ? {
  name: "1rzhsb9",
  styles: "padding:0;margin:0;position:absolute;top:-7px;left:8px;right:8px;display:flex;justify-content:flex-start;align-items:flex-start"
} : 0;

var _ref8 =  true ? {
  name: "1mj0uo6",
  styles: "font-family:Golos;position:absolute;top:30px;left:0;z-index:1;display:flex;flex-direction:row"
} : 0;

var _ref9 =  true ? {
  name: "194dkku",
  styles: "width:34px;height:34px;background:#fff;display:flex;justify-content:center;align-items:center;border-top-right-radius:4px;border-bottom-right-radius:4px;opacity:0.8"
} : 0;

var _ref10 =  true ? {
  name: "rrel8y",
  styles: "width:24px;height:24px"
} : 0;

var _ref11 =  true ? {
  name: "7rrzpj",
  styles: "display:flex;flex:1;flex-direction:column;justify-content:space-between;padding:20px 20px 40px"
} : 0;

var _ref12 =  true ? {
  name: "megt0k",
  styles: "color:#000;font-family:Golos;font-weight:400;font-size:12px;&>div{margin-bottom:6px;}"
} : 0;

var _ref13 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref14 =  true ? {
  name: "1jks8pm",
  styles: "& span:not(:last-child):after{content:\", \";}"
} : 0;

var _ref15 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref16 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref17 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref18 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref19 =  true ? {
  name: "1q5jn22",
  styles: "display:flex;align-items:center;margin-right:18px;height:16px;font-family:Golos;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:0.01em;svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

var _ref20 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref21 =  true ? {
  name: "1q5jn22",
  styles: "display:flex;align-items:center;margin-right:18px;height:16px;font-family:Golos;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:0.01em;svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

var _ref22 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref24 =  true ? {
  name: "15currb",
  styles: "display:flex;height:100%"
} : 0;

var _ref25 =  true ? {
  name: "nu06ps",
  styles: "border-radius:4px;position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden"
} : 0;

var _ref26 =  true ? {
  name: "1pi274v",
  styles: "width:100%;background:rgba(0, 0, 0, 0.7);color:#fff;padding:6px 0;z-index:10;position:absolute;left:0;bottom:0"
} : 0;

var _ref27 =  true ? {
  name: "lesovd",
  styles: "width:90%;margin:0 auto"
} : 0;

var _ref28 =  true ? {
  name: "1cxr13n",
  styles: "text-align:center;font-size:13px"
} : 0;

var _ref29 =  true ? {
  name: "1wox62x",
  styles: "width:100%;height:3px;background:#fff;border-radius:2px;margin-top:5px"
} : 0;

var _ref30 =  true ? {
  name: "1rzhsb9",
  styles: "padding:0;margin:0;position:absolute;top:-7px;left:8px;right:8px;display:flex;justify-content:flex-start;align-items:flex-start"
} : 0;

var _ref31 =  true ? {
  name: "1mj0uo6",
  styles: "font-family:Golos;position:absolute;top:30px;left:0;z-index:1;display:flex;flex-direction:row"
} : 0;

var _ref32 =  true ? {
  name: "194dkku",
  styles: "width:34px;height:34px;background:#fff;display:flex;justify-content:center;align-items:center;border-top-right-radius:4px;border-bottom-right-radius:4px;opacity:0.8"
} : 0;

var _ref33 =  true ? {
  name: "rrel8y",
  styles: "width:24px;height:24px"
} : 0;

var _ref34 =  true ? {
  name: "7rrzpj",
  styles: "display:flex;flex:1;flex-direction:column;justify-content:space-between;padding:20px 20px 40px"
} : 0;

var _ref35 =  true ? {
  name: "megt0k",
  styles: "color:#000;font-family:Golos;font-weight:400;font-size:12px;&>div{margin-bottom:6px;}"
} : 0;

var _ref36 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref37 =  true ? {
  name: "1jks8pm",
  styles: "& span:not(:last-child):after{content:\", \";}"
} : 0;

var _ref38 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref39 =  true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0;

var _ref40 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref41 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref42 =  true ? {
  name: "1q5jn22",
  styles: "display:flex;align-items:center;margin-right:18px;height:16px;font-family:Golos;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:0.01em;svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

var _ref43 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

var _ref44 =  true ? {
  name: "1q5jn22",
  styles: "display:flex;align-items:center;margin-right:18px;height:16px;font-family:Golos;font-size:12px;font-style:normal;font-weight:500;line-height:16px;letter-spacing:0.01em;svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

var _ref45 =  true ? {
  name: "157xhr7",
  styles: "width:16px;height:16px"
} : 0;

function PostCard(_ref) {
  var _objectSpread2, _objectSpread3;

  var item = _ref.item,
      currentCity = _ref.currentCity,
      catalog = _ref.catalog,
      scroll = _ref.scroll,
      withOutWrapper = _ref.withOutWrapper,
      href = _ref.href;
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_20__.u)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    showTimer: false,
    startDate: null,
    endDate: null,
    title: null
  }),
      timerData = _useState[0],
      setTimerData = _useState[1];

  var _useTimer = (0,react_timer_hook__WEBPACK_IMPORTED_MODULE_3__.useTimer)({
    expiryTimestamp: timerData.endDate ? luxon__WEBPACK_IMPORTED_MODULE_2__/* .DateTime.fromISO */ .ou.fromISO(timerData.endDate, {
      zone: 'utc'
    }).valueOf() : new Date().valueOf(),
    onExpire: function onExpire() {
      return console.warn('onExpire called');
    }
  }),
      seconds = _useTimer.seconds,
      minutes = _useTimer.minutes,
      hours = _useTimer.hours,
      days = _useTimer.days,
      restart = _useTimer.restart;

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
      progressValue = _useState2[0],
      setProgressValue = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var newTimerData = {
      showTimer: false,
      startDate: null,
      endDate: null,
      title: (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getTitleForTimer */ .KR)(item.countdown_type)
    };
    var dataPrepareForTimer = null;
    (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .countdownInit */ .Gw)([luxon__WEBPACK_IMPORTED_MODULE_2__/* .DateTime.fromISO */ .ou.fromISO(item.countdown_datetime)], item.countdown_type, function (countdown) {
      dataPrepareForTimer = countdown;
    });

    if (dataPrepareForTimer) {
      newTimerData.showTimer = true;
      newTimerData.endDate = moment__WEBPACK_IMPORTED_MODULE_4___default()().valueOf() + dataPrepareForTimer.date;
      newTimerData.startDate = moment__WEBPACK_IMPORTED_MODULE_4___default()(moment__WEBPACK_IMPORTED_MODULE_4___default()().valueOf() + dataPrepareForTimer.date).subtract(7, 'day');
    }

    if (newTimerData.showTimer) {
      var a = (Number(moment__WEBPACK_IMPORTED_MODULE_4___default()().valueOf()) - Number(newTimerData.startDate.valueOf())) * 100;
      var b = Number(moment__WEBPACK_IMPORTED_MODULE_4___default()(newTimerData.endDate).valueOf()) - Number(newTimerData.startDate.valueOf());
      var newProgressVal = Math.round(a / b);
      setProgressValue(newProgressVal);
      restart(newTimerData.endDate);
    }

    setTimerData(newTimerData);
  }, [item]);
  return withOutWrapper ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
    // action-card
    itemScope: true,
    itemType: "https://schema.org/Event",
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
      height: '100%',
      borderRadius: '4px',
      backgroundColor: '#fff',
      position: 'relative',
      top: 0,
      width: '100%',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: theme.constants.boxShadow
      }
    },  true ? "" : 0,  true ? "" : 0),
    children: [item.nearest_event && item.nearest_event.start_date && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("meta", {
      itemProp: "startDate",
      content: item.nearest_event.start_date
    }), item.nearest_event && item.nearest_event.end_date && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("meta", {
      itemProp: "startDate",
      content: item.nearest_event.end_date
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("meta", {
      itemProp: "name",
      content: item.title
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled_Link__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .rU // action-card__image-wrapper
    , {
      itemProp: "url",
      href: href || ['', currentCity.url, 'actions', item.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ,
      css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
        height: 0,
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        display: 'block',
        '&:hover': {
          color: theme.colors.black
        }
      },  true ? "" : 0,  true ? "" : 0),
      children: [item.image && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
        // action-card__image
        css: _ref2,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_picture_picture__WEBPACK_IMPORTED_MODULE_14__/* .Picture */ .t, {
          initWhiteBlackFilter: item.not_season,
          src: item.image,
          alt: item.title,
          is360: true
        })
      }), item.countdown_type && item.countdown_type !== 'unset' && timerData.showTimer && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
        css: _ref3,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
          css: _ref4,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("p", {
            css: _ref5,
            children: [timerData.title, " ", (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .formatTimer */ .NE)(days, hours, minutes, seconds)]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
            css: _ref6,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
              css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
                height: '100%',
                width: "".concat(progressValue, "%"),
                background: 'rgb(244, 67, 54)',
                borderRadius: 2,
                marginLeft: -1
              },  true ? "" : 0,  true ? "" : 0)
            })
          })]
        })
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("ul", {
      // action-card__label-container-sub
      css: _ref7,
      children: [item.not_season && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
        text: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D",
        title: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D"
      }), item.best_reviews && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
        text: "\u043B\u0443\u0447\u0448\u0438\u0435 \u043E\u0442\u0437\u044B\u0432\u044B",
        title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432\u044B\u0441\u043E\u043A\u043E \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u044E\u0442 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
      }), item.hit && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
        text: "\u0445\u0438\u0442",
        title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u044E\u0442 \u044D\u0442\u043E \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
      }), item.first_time && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
        text: "\u0432\u043F\u0435\u0440\u0432\u044B\u0435",
        title: "\u0421\u043E\u0431\u044B\u0442\u0438\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u043F\u0435\u0440\u0432\u044B\u0435"
      }), item.premiere && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
        text: "\u043F\u0440\u0435\u043C\u044C\u0435\u0440\u0430",
        title: "\u041F\u0440\u0435\u043C\u044C\u0435\u0440\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u044B \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
      }), item.prepayment && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
        text: "\u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0430",
        title: "\u041E\u043D\u043B\u0430\u0439\u043D \u0432\u044B \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0443"
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_favorite_FavoriteButtonCardWrapper__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_favorite_FavoriteButton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        kind: _models_favorite__WEBPACK_IMPORTED_MODULE_19__/* .FavoriteKinds.event */ .f.event,
        id: item.remote_id,
        size: "small",
        variant: "red-outline"
      })
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
      // action-card__label-block
      css: _ref8,
      children: [!item.instead_price && !item.filter_price && item.type !== _constants_events__WEBPACK_IMPORTED_MODULE_12__/* .eventTypes.restaurant */ .uS.restaurant && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .ActionLabelItem */ .F0 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      , {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
          borderRadius: item.pushkin_card_payment ? '0' : '0 4px 4px 0',
          backgroundColor: theme.colors.red,
          background: 'rgba(0, 102, 204, 0.80)'
        },  true ? "" : 0,  true ? "" : 0),
        children: "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
      }), !!item.discount && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .ActionLabelItem */ .F0 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      , {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
          borderRadius: item.pushkin_card_payment ? '0' : '0 4px 4px 0',
          backgroundColor: 'rgba(244, 67, 54, 0.80)'
        },  true ? "" : 0,  true ? "" : 0),
        children: ["\u2212", item.discount, "%\xA0\u0441\u043A\u0438\u0434\u043A\u0430"]
      }), item.pushkin_card_payment && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
        css: _ref9,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_pushkin_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          css: _ref10
        })
      })]
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
      // action-card__info
      css: _ref11,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
        // action-card__description
        css: _ref12,
        children: [item.filter_price && item.type !== _constants_events__WEBPACK_IMPORTED_MODULE_12__/* .eventTypes.restaurant */ .uS.restaurant ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .DescriptionItem */ .tH, {
          itemProp: "offers",
          itemScope: true,
          itemType: "https://schema.org/Offer",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_redRouble_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            css: _ref13
          }), !!item.instead_price && !!item.filter_price && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
            title: "\u0412\u0430\u0448\u0430 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u044F ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getBenefit */ .yM)(item.instead_price, item.filter_price)), "\u20BD"),
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
              css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
                color: theme.colors.textSecondary,
                opacity: '0.6',
                textDecoration: 'line-through'
              },  true ? "" : 0,  true ? "" : 0),
              children: [(0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)(item.instead_price), "\xA0"]
            }), ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
              itemProp: "price",
              children: [(0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)(item.filter_price), ' ']
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
              itemProp: "priceCurrency",
              content: "RUB",
              children: [' ', "\u0440\u0443\u0431\u043B\u0435\u0439"]
            })]
          }), !!item.filter_price && !item.instead_price && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
            children: [item.display_price && item.display_price.indexOf('от') !== -1 ? 'от ' : '', (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)(item.filter_price), " \u0440\u0443\u0431\u043B\u0435\u0439"]
          })]
        }) : '', item.type !== _constants_events__WEBPACK_IMPORTED_MODULE_12__/* .eventTypes.restaurant */ .uS.restaurant && !!item.dates_txt && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .DescriptionItem */ .tH // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        , {
          css: _ref14,
          children: item.has_further_dates && item.dates_txt ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .Fragment */ .HY, {
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_when_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              css: _ref15
            }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
              children: item.dates_txt
            })]
          }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
            css: _ref16,
            children: item.date_unknown && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .Fragment */ .HY, {
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_when_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                css: _ref17
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("p", {
                children: "\u0414\u0430\u0442\u0430 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F"
              })]
            })
          })
        }), item.place_title && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .DescriptionItem */ .tH, {
          itemProp: "location",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_location_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            fill: theme.colors.red,
            css: _ref18
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
            itemProp: "name",
            children: item.place_title
          })]
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled_Link__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .rU // action-card__title
      , {
        itemProp: "url",
        href: href || ['', currentCity.url, 'actions', item.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ,
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
          fontFamily: 'Montserrat',
          fontSize: '18px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '22px',
          letterSpacing: '0em',
          color: theme.colors.black,
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          '&:hover': {
            color: theme.colors.black
          }
        },  true ? "" : 0,  true ? "" : 0),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
          itemProp: "name",
          children: item.title
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
          position: 'absolute',
          bottom: '12px',
          right: '20px',
          left: '20px',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          color: theme.colors.grayStrong,
          fontSize: '12px',
          fontWeight: 500
        },  true ? "" : 0,  true ? "" : 0),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
          css: _ref19,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_views2_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            fill: theme.colors.grayStrong,
            css: _ref20
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
            children: item.views
          })]
        }), item.comments_avg_rating > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
          css: _ref21,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_star_outline_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            css: _ref22
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
            children: item.comments_avg_rating.toFixed(1)
          })]
        }), item.age_category && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
            fontFamily: 'Golos',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0.01em',
            marginLeft: 'auto',
            color: theme.colors.grayStrong
          },  true ? "" : 0,  true ? "" : 0),
          children: item.age_category
        })]
      })]
    })]
  }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
    // actions__item actions__item_scroll
    itemScope: true,
    itemType: "https://schema.org/Event" // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)(_objectSpread(_objectSpread(_objectSpread({}, theme.mixins.col(4)), {}, (_objectSpread2 = {
      marginBottom: 16
    }, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread2, _lib_consts__WEBPACK_IMPORTED_MODULE_16__/* .DEVICE_SCREENS_MAX_STRING.xl */ .fD.xl, _objectSpread({}, theme.mixins.col(3))), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread2, _lib_consts__WEBPACK_IMPORTED_MODULE_16__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, _objectSpread({}, theme.mixins.col(2))), _objectSpread2), scroll ? (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, _lib_consts__WEBPACK_IMPORTED_MODULE_16__/* .DEVICE_SCREENS_MAX_STRING.sm */ .fD.sm, _objectSpread(_objectSpread({}, theme.mixins.col(1.3)), {}, {
      marginBottom: 0
    })) : {}), catalog ? _objectSpread(_objectSpread({}, theme.mixins.col(3)), {}, (_objectSpread3 = {}, (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread3, _lib_consts__WEBPACK_IMPORTED_MODULE_16__/* .DEVICE_SCREENS_MAX_STRING.md */ .fD.md, _objectSpread({}, theme.mixins.col(2))), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_objectSpread3, _lib_consts__WEBPACK_IMPORTED_MODULE_16__/* .DEVICE_SCREENS_MAX_STRING.sm */ .fD.sm, _objectSpread({}, theme.mixins.col(1))), _objectSpread3)) : {}),  true ? "" : 0,  true ? "" : 0),
    className: "actions__item",
    children: [item.nearest_event && item.nearest_event.start_date && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("meta", {
      itemProp: "startDate",
      content: item.nearest_event.start_date
    }), item.nearest_event && item.nearest_event.end_date && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("meta", {
      itemProp: "startDate",
      content: item.nearest_event.end_date
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("meta", {
      itemProp: "name",
      content: item.title
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
      css: _ref24,
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
        // action-card
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
          height: '100%',
          borderRadius: '4px',
          backgroundColor: '#fff',
          position: 'relative',
          top: 0,
          width: '100%',
          transition: 'all 0.3s ease',
          display: 'flex',
          flexDirection: 'column',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.constants.boxShadow
          }
        },  true ? "" : 0,  true ? "" : 0),
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled_Link__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .rU // action-card__image-wrapper
        , {
          itemProp: "url",
          href: href || ['', currentCity.url, 'actions', item.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          ,
          css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
            height: 0,
            width: '100%',
            paddingBottom: '75%',
            position: 'relative',
            display: 'block',
            '&:hover': {
              color: theme.colors.black
            }
          },  true ? "" : 0,  true ? "" : 0),
          children: [(item.photo_preview || item.image) && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
            // action-card__image
            css: _ref25,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_picture_picture__WEBPACK_IMPORTED_MODULE_14__/* .Picture */ .t, {
              initWhiteBlackFilter: item.not_season,
              src: item.photo_preview || item.image,
              alt: item.title,
              is360: true
            })
          }), item.countdown_type && item.countdown_type !== 'unset' && timerData.showTimer && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
            css: _ref26,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
              css: _ref27,
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("p", {
                css: _ref28,
                children: [timerData.title, ' ', (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .formatTimer */ .NE)(days, hours, minutes, seconds)]
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
                css: _ref29,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
                  css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
                    height: '100%',
                    width: "".concat(progressValue, "%"),
                    background: 'rgb(244, 67, 54)',
                    borderRadius: 2,
                    marginLeft: -1
                  },  true ? "" : 0,  true ? "" : 0)
                })
              })]
            })
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("ul", {
          // action-card__label-container-sub
          css: _ref30,
          children: [item.not_season && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
            text: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D",
            title: "\u041D\u0435 \u0441\u0435\u0437\u043E\u043D"
          }), item.best_reviews && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
            text: "\u043B\u0443\u0447\u0448\u0438\u0435 \u043E\u0442\u0437\u044B\u0432\u044B",
            title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0432\u044B\u0441\u043E\u043A\u043E \u043E\u0446\u0435\u043D\u0438\u0432\u0430\u044E\u0442 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
          }), item.hit && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
            text: "\u0445\u0438\u0442",
            title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0447\u0430\u0441\u0442\u043E \u043F\u0440\u043E\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u044E\u0442 \u044D\u0442\u043E \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435"
          }), item.first_time && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
            text: "\u0432\u043F\u0435\u0440\u0432\u044B\u0435",
            title: "\u0421\u043E\u0431\u044B\u0442\u0438\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043E \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 \u0432\u043F\u0435\u0440\u0432\u044B\u0435"
          }), item.premiere && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
            text: "\u043F\u0440\u0435\u043C\u044C\u0435\u0440\u0430",
            title: "\u041F\u0440\u0435\u043C\u044C\u0435\u0440\u043D\u044B\u0435 \u043F\u043E\u043A\u0430\u0437\u044B \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
          }), item.prepayment && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .LabelFeatureListItem */ .CS, {
            text: "\u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0430",
            title: "\u041E\u043D\u043B\u0430\u0439\u043D \u0432\u044B \u0432\u043D\u043E\u0441\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0435\u0434\u043E\u043F\u043B\u0430\u0442\u0443"
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_favorite_FavoriteButtonCardWrapper__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_favorite_FavoriteButton__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
            kind: _models_favorite__WEBPACK_IMPORTED_MODULE_19__/* .FavoriteKinds.event */ .f.event,
            id: item.remote_id,
            size: "small",
            variant: "red-outline"
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
          // action-card__label-block
          css: _ref31,
          children: [!item.instead_price && !item.filter_price && item.type !== _constants_events__WEBPACK_IMPORTED_MODULE_12__/* .eventTypes.restaurant */ .uS.restaurant && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .ActionLabelItem */ .F0 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          , {
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
              borderRadius: item.pushkin_card_payment ? '0' : '0 4px 4px 0',
              backgroundColor: theme.colors.red,
              background: 'rgba(0, 102, 204, 0.80)'
            },  true ? "" : 0,  true ? "" : 0),
            children: "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E"
          }), !!item.discount && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .ActionLabelItem */ .F0 // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          , {
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
              borderRadius: item.pushkin_card_payment ? '0' : '0 4px 4px 0',
              backgroundColor: 'rgba(244, 67, 54, 0.80)'
            },  true ? "" : 0,  true ? "" : 0),
            children: ["\u2212", item.discount, "%\xA0\u0441\u043A\u0438\u0434\u043A\u0430"]
          }), item.pushkin_card_payment && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
            css: _ref32,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_pushkin_svg__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
              css: _ref33
            })
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
          // action-card__info
          css: _ref34,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
            // action-card__description
            css: _ref35,
            children: [item.filter_price && item.type !== _constants_events__WEBPACK_IMPORTED_MODULE_12__/* .eventTypes.restaurant */ .uS.restaurant ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .DescriptionItem */ .tH, {
              itemProp: "offers",
              itemScope: true,
              itemType: "https://schema.org/Offer",
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_redRouble_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                css: _ref36
              }), !!item.instead_price && !!item.filter_price && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
                title: "\u0412\u0430\u0448\u0430 \u044D\u043A\u043E\u043D\u043E\u043C\u0438\u044F ".concat((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .getBenefit */ .yM)(item.instead_price, item.filter_price)), "\u20BD"),
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
                  css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
                    color: theme.colors.textSecondary,
                    opacity: '0.6',
                    textDecoration: 'line-through'
                  },  true ? "" : 0,  true ? "" : 0),
                  children: [(0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)(item.instead_price), "\xA0"]
                }), ' ', (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
                  itemProp: "price",
                  children: (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)(item.filter_price)
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
                  itemProp: "priceCurrency",
                  content: "RUB",
                  children: [' ', "\u0440\u0443\u0431\u043B\u0435\u0439"]
                })]
              }), !!item.filter_price && !item.instead_price && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("span", {
                children: [item.display_price && item.display_price.indexOf('от') !== -1 ? 'от ' : '', (0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .splitPriceByThree */ .ax)(item.filter_price), " \u0440\u0443\u0431\u043B\u0435\u0439"]
              })]
            }) : '', item.type !== _constants_events__WEBPACK_IMPORTED_MODULE_12__/* .eventTypes.restaurant */ .uS.restaurant && !!item.dates_txt && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .DescriptionItem */ .tH // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            , {
              css: _ref37,
              children: item.has_further_dates && item.dates_txt ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .Fragment */ .HY, {
                children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_when_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                  css: _ref38
                }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
                  children: item.dates_txt
                })]
              }) : (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
                css: _ref39,
                children: item.date_unknown && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .Fragment */ .HY, {
                  children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_when_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    css: _ref40
                  }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("p", {
                    children: "\u0414\u0430\u0442\u0430 \u0443\u0442\u043E\u0447\u043D\u044F\u0435\u0442\u0441\u044F"
                  })]
                })
              })
            }), item.place_title && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .DescriptionItem */ .tH, {
              itemProp: "location",
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_location_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                fill: theme.colors.red,
                css: _ref41
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
                itemProp: "name",
                children: item.place_title
              })]
            })]
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_styled_Link__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .rU // action-card__title
          , {
            itemProp: "url",
            href: href || ['', currentCity.url, 'actions', item.slug, ''].join('/') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ,
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
              fontFamily: 'Montserrat',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '22px',
              letterSpacing: '0em',
              color: theme.colors.black,
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              flex: 1,
              '&:hover': {
                color: theme.colors.black
              }
            },  true ? "" : 0,  true ? "" : 0),
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
              itemProp: "name",
              children: item.title
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
              position: 'absolute',
              bottom: '12px',
              right: '20px',
              left: '20px',
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              color: theme.colors.grayStrong,
              fontSize: '12px',
              fontWeight: 500
            },  true ? "" : 0,  true ? "" : 0),
            children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
              css: _ref42,
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_views2_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                fill: theme.colors.grayStrong,
                css: _ref43
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
                children: item.views
              })]
            }), item.comments_avg_rating > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsxs */ .BX)("div", {
              css: _ref44,
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)(_public_img_star_outline_svg__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                css: _ref45
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("span", {
                children: item.comments_avg_rating.toFixed(1)
              })]
            }), item.age_category && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__/* .jsx */ .tZ)("div", {
              css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_22__/* .css */ .iv)({
                fontFamily: 'Golos',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '16px',
                letterSpacing: '0.01em',
                marginLeft: 'auto',
                color: theme.colors.grayStrong
              },  true ? "" : 0,  true ? "" : 0),
              children: item.age_category
            })]
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 3349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ LabelFeatureListItem; },
/* harmony export */   "F0": function() { return /* binding */ ActionLabelItem; },
/* harmony export */   "tH": function() { return /* binding */ DescriptionItem; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(917);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4730);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1463);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5944);



var _excluded = ["text", "title"],
    _excluded2 = ["children"],
    _excluded3 = ["children"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function LabelFeatureListItem(_ref) {
  var text = _ref.text,
      title = _ref.title,
      restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, _excluded);

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("li", _objectSpread(_objectSpread({
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
      display: 'block',
      textAlign: 'center',
      marginRight: '6px',
      background: theme.colors.red,
      borderRadius: '2px',
      fontFamily: 'Golos',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '100%',
      color: theme.colors.white,
      padding: '4px 10px'
    },  true ? "" : 0,  true ? "" : 0),
    title: title
  }, restProps), {}, {
    children: text
  }));
}
function ActionLabelItem(_ref2) {
  var children = _ref2.children,
      restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref2, _excluded2);

  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)({
      width: '100px',
      height: '34px',
      fontSize: '13px',
      fontWeight: 600,
      color: theme.colors.white,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)'
    },  true ? "" : 0,  true ? "" : 0)
  }, restProps), {}, {
    children: children
  }));
}

var _ref4 =  true ? {
  name: "vhuutz",
  styles: "display:flex;line-height:1.3;max-height:32px;overflow:hidden;&>svg{flex:0 0 auto;margin-right:5px;}"
} : 0;

function DescriptionItem(_ref3) {
  var children = _ref3.children,
      restProps = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref3, _excluded3);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    css: _ref4
  }, restProps), {}, {
    children: children
  }));
}

/***/ })

}]);